export default __webpack_public_path__ + "cbd31ce1c41b9959001c4a9d01c30c11.woff2";